<template>
  <div>
    <loading
      :name="firstname(registration['name'])"
      v-if="this.state == 'loading'"
    />
    <find-initial-focal-point
      :firstname="firstname(registration['name'])"
      :ceremony="this.registration.ceremony"
      v-if="this.state == 'initial'"
      @submit="submitFocalPoint"
    />
    <manual-submission-page
      v-if="this.state == 'fineTune'"
      :focalPoint="focalPoint"
      :ceremony="this.registration.ceremony"
      @submit="submitFineTune"
      :errors="this.errors"
      :audio="audio"
      :peaks="peaks"
      :initialIn="initialIn"
      :initialOut="initialOut"
      :initialAudioIn="initialAudioIn"
      :initialAudioOut="initialAudioOut"
    /> 
    <submitted
      v-if="this.state == 'submitted'"
      :name="firstname(registration['name'])"
    />
  </div>
</template>

<script>
import FindInitialFocalPoint from "./FindInitialFocalPoint.vue";
import ManualSubmissionPage from "./ManualSubmissionPage.vue";
import axios from "axios";
import Submitted from "./Submitted.vue";
import Loading from "../Loading.vue";
import {endSession, trackEvent} from "../../Analytics.vue"

export default {
  name: "FindStudentProcess",
  props: {
    organiser: Object
  },
  data: function () {
    return {
      state: "loading",
      min: null,
      max: null,
      focalPoint: 0,
      registration: {},
      errors: [],
      audio: "",
      peaks: null,
      initialIn: null,
      initialOut: null,
      initialAudioIn: null,
      initialAudioOut: null,
    };
  },
  computed: {},
  methods: {
    parseQueryNumber(key) {
      const value = this.$route.query[key];
      if (typeof value === "undefined") {
        return null;
      }
      const parsed = parseFloat(value);
      return Number.isFinite(parsed) ? parsed : null;
    },
    firstname(name) {
      return (name || "").split(" ")[0];
    },
    focalPointWithinInitialBounds(focalPoint) {
      return (
        this.initialIn !== null &&
        this.initialOut !== null &&
        focalPoint >= this.initialIn &&
        focalPoint <= this.initialOut
      );
    },
    loadAudioData() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + (localStorage.getItem("public_token") || localStorage.getItem("token"));
      return axios
        .get(`/universities/${this.organiser.id}/ceremonies/${this.registration.ceremony.id}/audio`)
        .then((audio_response) => audio_response.data)
        .then((response_data) => {
          this.audio = response_data.audio;
          this.peaks = response_data.waveform;
        })
        .catch(() => {
          this.audio = "";
          this.peaks = null;
        });
    },
    submitFocalPoint(data) {
      this.focalPoint = data;
      if (!this.focalPointWithinInitialBounds(data)) {
        // Outside of initial bounds, reset in/outs
        this.initialIn = null;
        this.initialOut = null;
        this.initialAudioIn = null;
        this.initialAudioOut = null;
      }
      this.loadAudioData().finally(() => {
        this.state = "fineTune";
      });
    },
    submitFineTune(data) {
      this.min = data.min;
      this.max = data.max;
      trackEvent(this.$route.path, {label: "MANUAL_SUBMISSION_END", registration_id: this.$route.params.id})
      const body = {
        in: this.min,
        out: this.max,
        include_audio: data.include_audio,
      };
      if (data.include_audio && data.audio_in !== null && data.audio_out !== null) {
        body.audio_in = data.audio_in;
        body.audio_out = data.audio_out;
      }
      axios
        .post(`/registrations/${this.$route.params.id}/submissions`, body)
        .then((response) => {
          trackEvent(this.$route.path, {label: "MANUAL_SUBMISSION_SUCCESS", registration_id: this.$route.params.id, submission_id: response.data["id"]})
          this.state = "submitted";
          console.log(response.data["id"]);
          endSession();
        })
        .catch((error) => {
          trackEvent(this.$route.path, {label: "MANUAL_SUBMISSION_FAIL", registration_id: this.$route.params.id, error:error.response.data["error"]})
          this.errors = [error.response.data["error"]];
        });
    },
  },
  beforeCreate() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + (localStorage.getItem("public_token") || localStorage.getItem("token"));
    axios
      .get(`/registrations/${this.$route.params.id}`)
      .then((response) => response.data)
      .then((response_data) => {
        this.registration = response_data;
        axios
          .get(`/ceremonies/${this.registration.ceremony}`)
          .then((ceremony_response) => ceremony_response.data)
          .then((response_data) => {
            this.registration.ceremony = response_data;
            this.initialIn = this.parseQueryNumber("initial_in");
            this.initialOut = this.parseQueryNumber("initial_out");
            this.initialAudioIn = this.parseQueryNumber("initial_audio_in");
            this.initialAudioOut = this.parseQueryNumber("initial_audio_out");
            const timecode = this.parseQueryNumber("timecode");
            if (this.initialIn !== null && this.initialOut !== null) {
              this.focalPoint = timecode !== null ? timecode : this.initialIn;
            }
            this.state = "initial";
          });
 
      });
      trackEvent(this.$route.path, {label: "MANUAL_SUBMISSION_START", registration_id: this.$route.params.id})
  },

  components: {
    FindInitialFocalPoint,
    ManualSubmissionPage,
    Submitted,
    Loading,
  },
};
</script>
<style scoped>
video {
  min-width: 100% !important;
  min-height: 40em;
  position: relative !important;
}
.video-js {
  width: 100% !important;
  position: relative !important;
}
</style>
